import React from "react";
import mobileRoadlineImg from "../../../images/mobile/mobile-road-map.png";

import config from "../../../config.json";
import Card from "../../../common/Card/Card";

function MobileRoadMapSection() {
  const styles = {
    0: { className: "bg-amber-300", styles: {} },
    1: {
      className: "bg-violet-200",
      styles: { marginLeft: '32%' },
    },
    2: {
      className: "bg-violet-400",
      styles: { marginRight: '32%' },
    },
    3: {
      className: "bg-amber-300",
      styles: { marginLeft: '26.3%' },
    },
    4: {
      className: "bg-violet-300",
      styles: { marginRight: '24%' },
    },
    5: {
      className: "bg-amber-200",
      styles: { marginLeft: '32%' },
    },
  };
  return (
    <section id="roadmap" className="">
      <h2 className="section-title text-center">Project roadmap</h2>
      <div
        className="flex flex-col relative items-center w-full"
        style={{ height: "100%", paddingLeft: '6.4%', paddingRight: '6.4%' }}
      >
        <img
          className="absolute flex items-center "
          src={mobileRoadlineImg}
          alt="orange-bg"
          style={{ zIndex: 0, height: "100%", maxHeight: 1150, top: 125  }}
        />
        {config.roadmap.map((item, index) => (
          <div
            key={index}
            className="relative flex justify-center"
            style={styles[index].styles}
          >
            <Card
              className={styles[index].className}
              title={item.date}
              description={item.text}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default MobileRoadMapSection;
